@if (availableTabs) {
    <sew-headline level="3" translate>STARTPAGE.ACCESSORIES_SERVICES.HEADLINE</sew-headline>
    <sew-tab-bar hierarchy="sub">
        @for (tab of availableTabs; track tab; let index = $index) {
            <sew-tab-bar-item
                [name]="tab.tabTitle | translate"
                [icon]="tab.icon"
                [selected]="activeTab === index"
                (click)="tabSelected(tab.component, index)"
            >
            </sew-tab-bar-item>
        }
        <!--
    ngComponentOutlet is intentionally placed outside of the <sew-tab-bar-item>
    as this will also inject it as a slot right into the <sew-tab-bar>.
    The reason for this alternative usage is that this allows us to place a click event:
    (click)="tabSelected(tab.component, index)" right onto the <sew-tab-bar-item>.
    Slotting directly into <sew-tab-bar-item> would result in click tracking even if the user clicked
    the slotted component instead of just the tab.
    -->
        @if (activeTab !== undefined && availableTabs[activeTab]) {
            <div *ngComponentOutlet="availableTabs[activeTab].component"></div>
        }
    </sew-tab-bar>
}
